var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStarBlueEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9998 34C28.8358 34 28.6718 33.96 28.5218 33.878L17.9998 28.14L7.47778 33.878C7.14178 34.062 6.73178 34.036 6.41978 33.814C6.10778 33.592 5.94978 33.212 6.01378 32.834L7.92978 21.342L0.293778 13.706C0.0297785 13.442 -0.0662213 13.05 0.0477787 12.694C0.161779 12.338 0.465779 12.074 0.835779 12.012L12.3338 10.096L17.1058 0.552C17.2758 0.214 17.6218 0 17.9998 0C18.3778 0 18.7258 0.214 18.8938 0.552L23.6658 10.096L35.1638 12.012C35.5338 12.074 35.8378 12.336 35.9518 12.694C36.0658 13.052 35.9718 13.442 35.7058 13.706L28.0698 21.342L29.9858 32.834C30.0478 33.212 29.8898 33.592 29.5798 33.814C29.4078 33.936 29.2038 34 28.9998 34ZM17.9998 26C18.1638 26 18.3298 26.04 18.4778 26.122L27.6758 31.138L26.0138 21.164C25.9598 20.846 26.0638 20.52 26.2938 20.292L32.9198 13.666L22.8358 11.986C22.5198 11.934 22.2498 11.732 22.1058 11.446L17.9998 3.234L13.8938 11.446C13.7498 11.732 13.4798 11.932 13.1638 11.986L3.07978 13.666L9.70578 20.292C9.93378 20.52 10.0378 20.844 9.98578 21.164L8.32378 31.138L17.5218 26.122C17.6718 26.04 17.8358 26 17.9998 26Z",
    fill: "#1BA2CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarBlueEmpty);
export default __webpack_public_path__ + "static/media/rating-star-blue-empty.f34da617be7be5e9a43f4ecc741f3e14.svg";
export { ForwardRef as ReactComponent };